import type { AppStateController } from '../app/state/AppStateController';
import { MS_IN_DAY } from '../utils/time-utils';
import type { Platform } from '../app/platform/Platform';

function checkIfExpired(state: AppStateController): void {
  const lastAddedDate = state.getAddedShortcutDate();
  if (lastAddedDate === null) return;
  if (Date.now() - lastAddedDate > MS_IN_DAY * 90) {
    state.setAddedShortcut(null);
  }
}

interface TryAddToFavouritesDependencies {
  state: AppStateController;
  platform: Platform;
  levelNumber: number;
}

export async function tryAddToFavourites({
  state,
  platform,
  levelNumber,
}: TryAddToFavouritesDependencies): Promise<void> {
  checkIfExpired(state);
  if (state.getAddedShortcutDate() !== null) return;

  if (levelNumber % 3 !== 2) return;

  const success = await platform.createShortcut();

  if (!success) return;

  state.setAddedShortcut(Date.now());
}
